module.exports = __webpack_public_path__ + "Roboto-RegularItalic.f3660f493ea5e5206484.eot";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-RegularItalic.eot
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-RegularItalic.eot
// module chunks = styles